/**
 * @fileoverview Connect the calendar workspace's event and navigation callbacks to `BespokeCalendar.js`. Parent components own form/detail selection, loaded data, and business actions. This adapter keeps visual navigation separate from event persistence and proposal review.
 */

import React from 'react';
import BespokeCalendar from './BespokeCalendar';



function CalendarInner({ 
  events, 
  scheduleXCalendarsConfig, 
  onEditEvent, 
  onDeleteEvent, 
  onConfirmResponsibility, 
  onAddEvent, 
  onViewChange,
  assignees
}) {
  return (
    <div className="calendar-wrapper">
      <BespokeCalendar
        events={events}
        scheduleXCalendarsConfig={scheduleXCalendarsConfig}
        onEventClick={onEditEvent}
        onDeleteEvent={onDeleteEvent}
        onConfirmResponsibility={onConfirmResponsibility}
        onAddEvent={onAddEvent}
        onViewChange={onViewChange}
        assignees={assignees}
      />
    </div>
  );
}

export default CalendarInner;